import { useState, useMemo,useEffect } from "react";
import CrossIcon from "../../../../assets/icons/maid-module-icons/CrossIcon.svg";
import { commonAPI } from "../../../../services/CommonAPIService";
import { ToastContainer, toast } from 'react-toastify';
import MobileNumber from "../components/Mobile"

const UpdateMobile = ({
  show,
  onHide,
  currentMobile,
  staffId,
  onSuccess,
  showAccessWarning,
}) => {
  const [loading, setLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showMasked, setShowMasked] = useState(false);
const [settingsLoading, setSettingsLoading] = useState(true);
  //   const [phoneDigits, setPhoneDigits] = useState(() => {
  //   if (currentMobile) {
  //     const digits = currentMobile.toString().split("").slice(0, 10);
  //     while (digits.length < 10) digits.push("");
  //     return digits;
  //   }
  //   return ["", "", "", "", "", "", "", "", "", ""];
  // });
  const [phoneDigits, setPhoneDigits] = useState(
  ["", "", "", "", "", "", "", "", "", ""]
);

useEffect(() => {
  const loadSetting = async () => {
    let userData = null;

    try {
      const auth = localStorage.getItem("userData");
      if (!auth) return;

      try {
        userData = JSON.parse(auth);
      } catch (parseErr) {
        throw new Error("Invalid userData format");
      }

      const response = await commonAPI("AppSettings", undefined, {
        buildingId: userData?.buildingId,
      });

      if (response?.success === true && Array.isArray(response.data)) {
        const setting = response.data.find(
          item =>
            item.key ===
            "SERVICE_STAFF_MOBILE_NBR_DIALER_VISIBILITY"
        );

        const roles =
          setting?.value?.toLowerCase()?.split("|") || [];

        setShowMasked(!roles.includes("admin"));
      }

    } catch (error) {
      console.error(
        "Error loading SERVICE_STAFF_MOBILE_NBR_DIALER_VISIBILITY:",
        error
      );

      const bodyError = {
        userId: userData?.userId || null,
        mobileNumber: userData?.mobileNumber || null,
        requestJSON: null,
        uri: "/api/Master/AppSettings",
        errorSource: "CuroNextPortal",
        errorNumber: "UPDTMOB01",
        errorSummary: error?.message,
        errorDescription: error?.message,
        fileClassName: "UpdateMobile.js",
        functionName: "loadSetting",
      };

      try {
        await commonAPI("ErrorLogMaster", bodyError);
      } catch (logErr) {
        console.error("Error while logging error:", logErr);
      }

      setShowMasked(false);
    } finally {
      setSettingsLoading(false);
    }
  };

  loadSetting();
}, []);

const maskMobileNumber = (number) => {
  if (!number) return "—";
  const str = String(number);
  if (str.length < 4) return str;
  return str.slice(0, 2) + "*".repeat(str.length - 4) + str.slice(-2);
};

  const myUserData = useMemo(() => {
    const auth = localStorage.getItem("userData");
    if (!auth) return null;
    return JSON.parse(auth);
  }, []);

  if (!show) return null;

 const updateMobileNumber = async () => {
  if (!myUserData) {
    toast.error("User data not found. Please log in again.");
    return;
  }

  if (!staffId) {
    toast.error("Staff details not available.");
    return;
  }

  let newMobile = "";

  try {
    setLoading(true);

    newMobile = phoneDigits.join("");

    // Validation
    if (newMobile.length !== 10) {
      toast.warning("Please enter a complete 10-digit mobile number");
      return;
    }

    if (!/^\d{10}$/.test(newMobile)) {
      toast.warning("Mobile number must contain only digits");
      return;
    }

    if (currentMobile && newMobile === currentMobile) {
      toast.warning(
        "Mobile number cannot be the same as the previously entered number."
      );
      return;
    }

    const payload = {
      staffId: staffId,
      value: {
        mobileNumber: newMobile,
      },
      key: "PERSONALINFO",
      modifiedUserId: String(staffId),
    };

    const response = await commonAPI(
      "UpdateServiceStaffDetail",
      payload,
      { buildingId: myUserData?.buildingId }
    );

    if (response?.success === true) {
      if (showAccessWarning) {
        const revokeResponse = await commonAPI(
          "ServiceStaffRevokeAppAccess",
          {
            modifiedUserId: JSON.stringify(myUserData?.userId),
            staffId,
          },
          { buildingId: myUserData?.buildingId }
        );

        if (
          revokeResponse?.success !== true ||
          (Array.isArray(revokeResponse?.message) &&
            revokeResponse.message.length > 0)
        ) {
          const revokeMessage = Array.isArray(revokeResponse?.message)
            ? revokeResponse.message[0]
            : revokeResponse?.message;
          throw new Error(revokeMessage || "Failed to revoke app access");
        }
      }

      toast.success("Mobile number updated successfully");
      onSuccess();
      onHide();
    } 
    else {
      toast.error(response?.message?.[0] || "Failed to update mobile number");
    }
  } catch (error) {
    console.error("Error updating mobile number:", error);

    const bodyError = {
      userId: myUserData?.userId || null,
      mobileNumber: myUserData?.mobileNumber || null,
      requestJSON: JSON.stringify({
        staffId,
        mobileNumber: newMobile,
      }),
      uri: "/api/User/ServiceStaffV1",
      errorSource: "CuroNextPortal",
      errorNumber: "UPDTMOB02",
      errorSummary: error?.message,
      errorDescription: error?.message,
      fileClassName: "UpdateMobile.js",
      functionName: "handleSave",
    };

    try {
      await commonAPI("ErrorLogMaster", bodyError);
    } catch (logErr) {
      console.error("Error while logging error:", logErr);
    }

    toast.error("An error occurred. Please try again.");
  } finally {
    setLoading(false);
  }
};

 const handleSave = () => {
  const newMobile = phoneDigits.join("");

  if (newMobile.length !== 10) {
    toast.warning("Please enter a complete 10-digit mobile number");
    return;
  }

  if (!/^\d{10}$/.test(newMobile)) {
    toast.warning("Mobile number must contain only digits");
    return;
  }

  if (currentMobile && newMobile === String(currentMobile)) {
    toast.warning(
      "Mobile number cannot be the same as the previously entered number."
    );
    return;
  }

  if (showAccessWarning) {
    setShowConfirmation(true);
    return;
  }

  updateMobileNumber();
};

  return (
    <>
      {/* Toast Container */}
      <ToastContainer />
      
      {/* Backdrop */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.45)",
          zIndex: 1080,
        }}
      />

      {/* Modal */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 1090,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 16px",
        }}
      >
        <div
          className="bg-white d-flex flex-column"
          style={{
            width: "100%",
            maxWidth: 600,
            height: "96vh",
            maxHeight: "calc(100vh - 32px)",
            borderRadius: 18,
            overflow: "hidden",
            fontFamily: "Inter, sans-serif",
          }}
        >
          {/* Header */}
          <div
            className="d-flex justify-content-between align-items-center text-white"
            style={{
              backgroundColor: "#1C80D2",
              padding: "12px 16px",
            }}
          >
            <h5
              className="mb-0"
              style={{
                fontSize: "clamp(14px, 4vw, 18px)",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              Update Mobile Number
            </h5>
            <button
              className="btn p-0 d-flex align-items-center justify-content-center bg-white"
              style={{
                width: 24,
                height: 24,
                borderRadius: 6,
                flexShrink: 0,
              }}
              onClick={onHide}
            >
              <img src={CrossIcon} alt="cross" />
            </button>
          </div>

                   {/* Body */}
                    <div
                    className="flex-grow-1" 
                    style={{
                        overflowY: "auto",    
                        display: "flex",       
                        flexDirection: "column", 
                        padding: "24px 16px",
                           }}
                    >
            
            <MobileNumber
              phoneDigits={phoneDigits}
              setPhoneDigits={setPhoneDigits}
            />
              {currentMobile && (
                <div
                  style={{
                    marginTop: 20,
                    fontSize: 14,
                    color: "#000000",
                    textAlign: "center",
                    fontWeight: 500,
                  }}
                >
                  <div style={{ marginBottom: 4 }}>
                    Previously entered no:
                  </div>

                  <div style={{ fontWeight: 600 }}>
                    {settingsLoading
                      ? "..."
                      : showMasked
                      ? maskMobileNumber(currentMobile)
                      : currentMobile}
                  </div>
                        {showAccessWarning && (
        <div
  style={{
    margin: "16px auto 0",
    padding: "10px 12px",
    backgroundColor: "#fff7ed",
    border: "1px solid #fed7aa",
    borderRadius: "6px",
    color: "#9a3412",
    fontSize: "12px",
    lineHeight: 1.5,
    textAlign: "left",
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
  }}
>
  <span
    style={{
      fontSize: "14px",
      lineHeight: "18px",
      flexShrink: 0,
    }}
  >
    ⚠️
  </span>

  <span>
    <strong>Note:</strong> Updating your mobile number will revoke your
    current app access. You will need to request app access again using your
    updated number.
  </span>
</div>
      )}
                </div>
              )}
          </div>

          {/* Buttons */}
          <div style={{ padding: "16px" }}>
            <div style={{ display: "flex", gap: 12 }}>
              <button
                onClick={onHide}
                className="btn"
                style={{
                  flex: 1,
                  background: "#FFFFFF",
                  color: "#1C80D2",
                  borderRadius: 30,
                  padding: "clamp(12px, 3vw, 14px)",
                  fontWeight: 600,
                  fontSize: "clamp(14px, 3vw, 15px)",
                  border: "1px solid #1C80D2",
                }}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="btn"
                style={{
                  flex: 1,
                  background: "#1C80D2",
                  color: "#FFFFFF",
                  borderRadius: 30,
                  padding: "clamp(12px, 3vw, 14px)",
                  fontWeight: 600,
                  fontSize: "clamp(14px, 3vw, 15px)",
                  border: "none",
                }}
                disabled={loading}
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {showConfirmation && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1100,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
          }}
        >
          <div
            className="bg-white"
            style={{
              width: "100%",
              maxWidth: 400,
              borderRadius: 10,
              overflow: "hidden",
            }}
          >
            <div
              className="d-flex justify-content-between align-items-center text-white"
              style={{
                backgroundColor: "#2E333F",
                padding: "12px 16px",
              }}
            >
              <h6 className="mb-0 fw-bold">Update Mobile Number</h6>
              <button
                type="button"
                onClick={() => setShowConfirmation(false)}
                className="btn p-0 d-flex align-items-center justify-content-center bg-white"
                style={{ width: 24, height: 24, borderRadius: 5 }}
                disabled={loading}
              >
                <img src={CrossIcon} alt="Close" />
              </button>
            </div>

            <div className="text-center" style={{ padding: "24px 20px 20px" }}>
              <p style={{ fontSize: 14, lineHeight: 1.5, marginBottom: 24 }}>
                Updating your mobile number will revoke your current app access.
                Are you sure you want to continue?
              </p>
              <div className="d-flex justify-content-center gap-3">
                <button
                  type="button"
                  onClick={() => setShowConfirmation(false)}
                  className="btn"
                  style={{
                    minWidth: 96,
                    borderRadius: 7,
                    border: "1px solid #3195D3",
                    background: "#FFFFFF",
                    color: "#3195D3",
                    fontSize: 12,
                  }}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowConfirmation(false);
                    updateMobileNumber();
                  }}
                  className="btn"
                  style={{
                    minWidth: 96,
                    borderRadius: 7,
                    border: "none",
                    background: "#3195D3",
                    color: "#FFFFFF",
                    fontSize: 12,
                  }}
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateMobile;